import { CloseRounded, Delete } from '@mui/icons-material'
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { deleteResource } from '../../../../../redux/actions/resources'
import { CancelButton, DeleteButton } from '../../../../shared/components/inputs'
import { StyledDialog } from '../../../../shared/styles/StyledDialog'

function DialogConfirmationDelete({ openDeleteResource, setOpenDeleteResource, resourceSelected }: any) {
  const dispatch = useDispatch()
  const { t } = useTranslation(['global'])

  return (
    <StyledDialog
      open={openDeleteResource}
      onClose={() => setOpenDeleteResource(!openDeleteResource)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">
            {t('delete')} {t('document')}
          </Typography>
          <Button onClick={() => setOpenDeleteResource(!openDeleteResource)} color="primary" variant="text">
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: 3, paddingTop: 2 }}>
        <Grid container alignItems="flex-start" spacing={2}>
          <Grid xs={12}>
            <Typography>{t('confirm-delete')}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={() => setOpenDeleteResource(!openDeleteResource)}>{t('cancel')}</CancelButton>
        <DeleteButton
          autoFocus
          id="btn-handleldelete"
          endIcon={<Delete />}
          onClick={() => {
            dispatch(deleteResource(resourceSelected))
            setOpenDeleteResource(!openDeleteResource)
          }}
        >
          {t('delete')}
        </DeleteButton>
      </DialogActions>
    </StyledDialog>
  )
}

export default DialogConfirmationDelete
